<div *ngIf="slotPrimary" class="symbol__slot symbol__slot--primary">
  <ng-container
    *ngTemplateOutlet="
      isSymbolIcon(slotPrimary) ? iconSymbol : $any(slotPrimary);
      context: slotPrimaryContext
    "
  ></ng-container>
</div>

<div class="text__slot">
  <ng-container *ngTemplateOutlet="labelIsTemplate ? $any(label) : labelTpl"></ng-container>
</div>

<div *ngIf="slotSecondary" class="symbol__slot symbol__slot--secondary">
  <ng-container
    *ngTemplateOutlet="
      isSymbolIcon(slotSecondary) ? iconSymbol : $any(slotSecondary);
      context: slotSecondaryContext
    "
  ></ng-container>
</div>

<ng-template #labelTpl>
  {{ label }}
</ng-template>

<ng-template #iconSymbol let-context [ngTemplateType]="SlotContext">
  <rt-icon [name]="context.icon" [size]="context.size"></rt-icon>
</ng-template>
